import { ILayoutElement } from "@faire/web-api/indigofair/data/ILayoutElement";
import { ISimpleBrandTile } from "@faire/web-api/indigofair/data/ISimpleBrandTile";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import * as React from "react";

import {
  BaseCarouselProps,
  CarouselBase,
  IProps,
} from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { SamplesRequestModalSource } from "@faire/retailer/components/Modals/SamplesRequestModal/types";
import { SampleBrandTile } from "@faire/retailer/components/SampleBrandTile/SampleBrandTile";

export const SampleRequestCarousel: React.FC<BaseCarouselProps> = (props) => {
  const {
    layoutElement,
    requestId,
    onItemClick,
    onVisible,
    useLazyImageLoading,
  } = React.useContext(Context);
  const { layout_element_data } = layoutElement;
  const items = layout_element_data
    .map((elementData) => elementData.simple_brand_tile)
    .filter(isNotUndefined);
  const sourcePage = getCarouselSource(layoutElement.display_page);

  const onItemClickHandler = (token: string) => {
    const { on_click_event_name } = layoutElement;
    if (on_click_event_name && token) {
      onItemClick?.(on_click_event_name, requestId, token);
    }
  };

  const renderSampleBrandTile = (simpleBrandTile: ISimpleBrandTile) => {
    return (
      <SampleBrandTile
        simpleBrandTile={simpleBrandTile}
        key={simpleBrandTile.token}
        sourcePage={sourcePage}
        onClick={onItemClickHandler}
        useLazyImageLoading={useLazyImageLoading}
      />
    );
  };

  const commonProps: IProps<ISimpleBrandTile> = {
    items: items,
    renderItem: renderSampleBrandTile,
    itemsPerSlide: {
      mobileAndAbove: 1,
      tabletAndAbove: 3,
      desktopAndAbove: 5,
    },
    peekGapPercent: 50,
    swipeableLeftPadding: 0,
    ...props,
  };

  const CarouselBaseComponent = CarouselBase as React.ComponentType<
    IProps<ISimpleBrandTile>
  >;
  const onItemsVisible = (items: ISimpleBrandTile[]) => {
    const itemTokens = items.map((item) => item?.token);
    if (layoutElement.on_click_event_name) {
      onVisible?.(
        layoutElement.on_click_event_name,
        requestId,
        itemTokens?.join(" ") ?? ""
      );
    }
  };

  return (
    <CarouselBaseComponent
      peekNextPercent={
        props.peekNextPercent ?? {
          mobileAndAbove: 50,
          tabletAndAbove: 0,
        }
      }
      itemGap={
        props.itemGap ?? {
          mobileAndAbove: 16,
          tabletAndAbove: 24,
        }
      }
      onItemsVisible={onItemsVisible}
      {...commonProps}
    />
  );
};

const getCarouselSource = (
  displayPage: keyof typeof ILayoutElement.DisplayPage | undefined
): SamplesRequestModalSource | undefined => {
  switch (displayPage) {
    case ILayoutElement.DisplayPage.CATEGORY_PAGE:
      return "C1";
    case ILayoutElement.DisplayPage.HOMEPAGE:
      return "HOME";
    case ILayoutElement.DisplayPage.LANDING_PAGE:
      return "LANDING-PAGE";
    default:
      return undefined;
  }
};
